import { FormikProps, FormikValues } from "formik";
import { useTranslation } from "next-i18next";
import React from "react";

import ActionButton from "../../buttons/action-button";
import { KINDS, SIZES } from "../../buttons/buttons.constants";

const Footer: React.FC<FormikProps<FormikValues>> = ({ isSubmitting, submitForm }) => {
    const { t } = useTranslation();
    return (
        <ActionButton
            disabled={isSubmitting}
            fluid={true}
            kind={KINDS.PRIMARY}
            size={SIZES.LARGE}
            label={t("buttons.submit")}
            onClick={submitForm}
        />
    );
};

export default Footer;
